export default __webpack_public_path__ + "static/media/free-CMT-banner.ae0c8e73.png";